import React from 'react';

// Shared hospital "visual identity" helpers used across Browse and the hospital
// detail page, so both feel like one designed system.

// Deterministic avatar tile: initials + a stable background color derived from
// the name, so a hospital looks the same everywhere (no real logos needed).
const AVATAR_COLORS = ['#0f766e', '#0369a1', '#7c3aed', '#b45309', '#be123c', '#15803d', '#0891b2', '#9333ea'];

export const getHospitalAvatar = (name) => {
    const clean = String(name || '').trim();
    const words = clean.split(/\s+/).filter(Boolean);
    const initials = ((words[0]?.[0] || '') + (words[1]?.[0] || words[0]?.[1] || '')).toUpperCase() || 'V';
    let hash = 0;
    for (let i = 0; i < clean.length; i += 1) {
        hash = (hash * 31 + clean.charCodeAt(i)) >>> 0;
    }
    return { initials, color: AVATAR_COLORS[hash % AVATAR_COLORS.length] };
};

// Whole-dollar formatting for headline figures (no cents), e.g. $1,456.
export const formatDollars = (value) => `$${Math.round(Number(value) || 0).toLocaleString()}`;

export const PinIcon = () => (
    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M21 10c0 6-9 12-9 12s-9-6-9-12a9 9 0 0 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
    </svg>
);

export const DocIcon = () => (
    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <path d="M14 2v6h6" />
        <path d="M8 13h8M8 17h5" />
    </svg>
);

export const ChartIcon = () => (
    <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M3 3v18h18" />
        <rect x="7" y="12" width="3" height="6" />
        <rect x="12" y="8" width="3" height="10" />
        <rect x="17" y="4" width="3" height="14" />
    </svg>
);

export const CheckIcon = () => (
    <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M20 6L9 17l-5-5" />
    </svg>
);
